<div [ngClass]="customCssClass"></div>
